var map = {
	"./add_photo_H.png": "8Fsy",
	"./add_photo_V.png": "Qsb5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SjEA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/add_photo_.*\.png$
// module id = SjEA
// module chunks = 1